import { render, staticRenderFns } from "./class-recommendation-and-note-form.vue?vue&type=template&id=55a7d888"
import script from "./class-recommendation-and-note-form.vue?vue&type=script&lang=js"
export * from "./class-recommendation-and-note-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports